import React, { useCallback, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { styleUtils } from 'styles'

const Root = styled.div`
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    top: -0.5rem;
    left: -0.75rem;
    right: -0.75rem;
    bottom: -0.5rem;
    background-color: ${({ theme }) =>
      styleUtils.colors.fade(theme.colors.text, 0)};
    border-radius: ${({ theme }) => theme.borderRadius}rem;
    transform: scale(0.5);
    transition: 0.2s background, transform ${({ theme }) => theme.ease};
  }

  &:hover {
    &:before {
      background-color: ${({ theme }) =>
        styleUtils.colors.fade(theme.colors.text, 0.04)};
      transform: scale(1);
    }
  }

  &:active {
    &:before {
      background-color: ${({ theme }) =>
        styleUtils.colors.fade(theme.colors.text, 0.08)};
      transform: scale(1);
    }
  }

  & > p {
    user-select: none;
    pointer-events: none;
    font-size: 1rem;
    line-height: 1rem;
    transition: 0.16s opacity ${({ theme }) => theme.ease};
    color: ${({ theme }) => theme.colors.lavender};
    opacity: 0.64;
    margin: 0;
    text-transform: capitalize;
  }

  .active& p,
  &:hover > p {
    opacity: 1;
    color: ${({ theme }) => theme.colors.primary};
  }

  & + & {
    margin-left: 1.5rem;
  }
`

export const Tab = ({ active, label, onClick, reportActive, value }) => {
  const ref = useRef()

  useEffect(() => {
    if (active) {
      reportActive({
        dims: [ref.current.clientWidth, ref.current.offsetLeft],
      })
    }
  }, [active, reportActive])

  const handleClick = useCallback(() => onClick?.(value), [onClick, value])

  return (
    <Root className={active ? 'active' : null} onClick={handleClick} ref={ref}>
      <p>{label}</p>
    </Root>
  )
}

Tab.propTypes = {
  /**
   * @desc Provided by the Tab parent component
   */
  active: PropTypes.bool,
  label: PropTypes.string.isRequired,
  /**
   * @desc Provided by the Tab parent component
   */
  onClick: PropTypes.func,
  /**
   * @desc Provided by the Tab parent component
   */
  reportActive: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}
